var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$slots.default && _vm.index == _vm.tab.sharedState.currentSelectedIndex)?_c('div',{staticClass:"w-tab-pane bg-white"},[_c('div',{staticClass:"p-4"},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }